


























import { Vue, Component, Prop } from 'vue-property-decorator';
import { EFieldSource } from '@/api/fields/types/field-source';

@Component
export default class FieldContentContainer extends Vue {
  @Prop() source: EFieldSource;
  @Prop({ default: false }) isRequired: boolean;
  @Prop({ default: false }) isActive: boolean;
  @Prop({ default: false }) hasValue: boolean;
  @Prop({ default: false }) invalid: boolean;
  @Prop({ default: false }) checkbox?: boolean;
  @Prop({ default: true }) hasValidatedValue: boolean;
  @Prop() showInitials: boolean;
  @Prop() scaleInitials: boolean;

  get sourceClass(): string {
    switch (this.source) {
      case EFieldSource.Sender:
        return 'sender-field';
      case EFieldSource.Recipient:
        return 'recipient-field';
      case EFieldSource.Document:
        return 'document-field';
      default:
        return '';
    }
  }
}
